import { default as highscoresKj7QypN4VtMeta } from "/opt/buildhome/repo/pages/highscores.vue?macro=true";
import { default as indexniDiYCWjuTMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as _91round_938xEZekfQ5lMeta } from "/opt/buildhome/repo/pages/reveal/[round].vue?macro=true";
import { default as submitncK2xGnt02Meta } from "/opt/buildhome/repo/pages/submit.vue?macro=true";
export default [
  {
    name: "highscores",
    path: "/highscores",
    component: () => import("/opt/buildhome/repo/pages/highscores.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "reveal-round",
    path: "/reveal/:round()",
    component: () => import("/opt/buildhome/repo/pages/reveal/[round].vue")
  },
  {
    name: "submit",
    path: "/submit",
    meta: submitncK2xGnt02Meta || {},
    component: () => import("/opt/buildhome/repo/pages/submit.vue")
  }
]